<template>
  <header class="header-message">
    <section class="header-message__content">
      <aside class="header-message__content__icon" :class="[getBadgeType]" v-if="showBadge">
        <Component v-if="badgeIcon" class="icon" :is="badgeIcon" />

        <label class="label" translate="no">
          {{ badgeMessage }}
        </label>
      </aside>

      <h1 class="header-message__content__heading" v-html="heading" />
      <h2 class="header-message__content__subheading" v-html="subheading" v-if="hasSubheading" />
    </section>
    <slot />
  </header>
</template>

<script>
export default {
  name: 'HeaderMessage',

  props: {
    badgeIcon: { type: String, default: 'CheckSvg' },
    badgeMessage: { type: String, default: '' },
    badgeType: { type: String, default: 'primary' },
    heading: String,
    showBadge: Boolean,
  },

  computed: {
    getBadgeType() {
      const customClass = {
        warning: 'is-warning',
        success: 'is-success',
      };
      return customClass[this.badgeType] || 'is-primary';
    },
  },
};
</script>

<style lang="scss" scoped>
.header-message {
  background-color: #002fdb;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.24);
  color: #fff;
  padding: 24px 24px 24px;
  position: relative;
  text-align: center;
  transition: all 0.3s ease-in-out;
  z-index: 9;

  %top-layer {
    position: relative;
    z-index: 1;
  }

  &__content {
    margin: auto;
    max-width: 310px;
    width: 100%;

    &__icon {
      @extend %top-layer;

      align-items: center;
      border-radius: 24px;
      display: flex;
      justify-content: space-evenly;
      margin: auto;
      margin-bottom: $gap-default;
      padding: 8px;
      transition: all 0.1s;
      min-width: 171px;
      max-width: 100%;
      width: fit-content;
    }

    &__heading {
      @extend %top-layer;

      color: #fff;
      font: {
        size: 20px;
        weight: 700;
      }
      line-height: 24px;
      padding-bottom: 16px;
      transition: all 0.1s;
    }

    &__subheading {
      @extend %top-layer;

      color: #fff;
      font: {
        size: 16px;
        weight: 500;
      }
      line-height: 24px;
      transition: all 0.1s;
      padding-bottom: 16px;
    }
  }
}

.is-primary {
  background-color: rgba(254, 254, 254, 0.12);
  border: 1px solid #fefefe;
  .icon {
    fill: #fff;
    width: 18px;
    align-self: center;
  }

  .label {
    margin-left: 9px;
    font-size: 14px;
    color: #fefefe;
  }
}

.is-success {
  background-color: #e8f8ec;
  border: 1px solid #fefefe;
  .icon {
    fill: #2d954c;
    width: 14px;
  }

  .label {
    margin-left: 9px;
    font-size: 14px;
    color: #22723a;
    font-weight: 500;
  }
}

.is-warning {
  background-color: #fef1e6;
  border: 1px solid #fefefe;
  .icon {
    fill: #a04c03;
    width: 18px;
  }

  .label {
    margin-left: 9px;
    font-size: 14px;
    color: #a04c03;
  }
}
</style>
